// utils/personalBest.js

export const savePersonalBest = (stats) => {
    const current = getPersonalBest();
    if (!current || stats.daysSurvived > current.daysSurvived || 
        (stats.daysSurvived === current.daysSurvived && stats.moneyEarned > current.moneyEarned)) {
      localStorage.setItem("personal_best", JSON.stringify({
        daysSurvived: stats.daysSurvived,
        moneyEarned: stats.moneyEarned,
        timestamp: new Date().toISOString()
      }));
      return true;
    }
    return false;
  };

  
export const getPersonalBest = () => {
    const saved = localStorage.getItem("personal_best");
    return saved ? JSON.parse(saved) : null;
};


/**
 * Checks if the current stats indicate the user is on track to achieve a new personal best.
 * @param {Object} currentStats - The current game statistics.
 * @param {number} currentStats.daysSurvived - The number of days the user has survived.
 * @param {number} currentStats.moneyEarned - The amount of money the user has earned.
 * @returns {boolean} - Returns true if on track for a new personal best, else false.
 */
export const isRecordRun = (currentStats) => {
    const personalBest = getPersonalBest();
    if (!personalBest) {
        // No personal best exists yet
        return true;
    }

    // Check if current stats exceed personal best
    if (currentStats.daysSurvived > personalBest.daysSurvived) {
        return true;
    }

    if (currentStats.daysSurvived === personalBest.daysSurvived && currentStats.moneyEarned > personalBest.moneyEarned) {
        return true;
    }

    return false;
};